function Bio({ text, skills }) {
  return (
    <div className="bio-container">
      <h3>About Me</h3>
      <p className="bio-text">{text}</p>

      <h3>Skills</h3>
      <div className="skill-container">
        {skills.map((skill, index) => (
          <span key={index} className="skill-tag">
            {skill}
          </span>
        ))}
      </div>
    </div>
  );
}

export default Bio;
